const SystemControlFlights = () =>{
    return(
        <>
            <section>
                <h2 className="uppercase font-medium w-full
                    xl:text-4xl xl:pb-12
                    lg:text-4xl lg:pb-12
                    md:text-3xl md:pb-10
                    sm:text-[28px] sm:pb-4">Система контроля полетов</h2>
                <div className="sm:flex sm:flex-col md:grid md:grid-cols-[45%_45%]  xl:grid xl:grid-cols-[45%_45%]  lg:grid lg:grid-cols-[45%_45%] gap-4">
                    <div className="flex flex-col md:pl-2 lg:pl-16 sm:gap-6 md:gap-10 lg:gap-12 xl:gap-16">
                        <div className="flex items-center gap-10">
                            {/* <img src='' alt=""/> */}
                            <div className="w-[30px] h-[30px] bg-slate-700 rounded-md"></div>
                            <div>
                                <h3>Удаленное управление</h3>
                                <p>Aliquam erat volutpat. Integer malesuada </p>
                            </div>
                        </div>

                        <div className="flex items-center gap-10">
                            {/* <img src='' alt=""/> */}
                            <div className="w-[30px] h-[30px] bg-slate-700 rounded-md"></div>
                            <div>
                                <h3>Удаленное управление</h3>
                                <p>Aliquam erat volutpat. Integer malesuada </p>
                            </div>
                        </div>

                        <div className="flex items-center gap-10">
                            {/* <img src='' alt=""/> */}
                            <div className="w-[30px] h-[30px] bg-slate-700 rounded-md"></div>
                            <div>
                                <h3>Удаленное управление</h3>
                                <p>Aliquam erat volutpat. Integer malesuada </p>
                            </div>
                        </div>

                        <a className="cursor-pointer text-[#304DB6]"> Ознакомиться с документацией</a>
                    </div>
                    <div className=" bg-slate-700"></div>
                </div>
            </section>
        </>
    )
}
export default SystemControlFlights;